/**
 * MOCK admin-managed category list (FR-2, FR-29). In prod these come from the town's
 * TenantSettings/Category entities. Each carries the routing department shown as helper text on
 * the radio-card (intake/spec §3.2) — the category, not the resident, decides the department.
 */
export interface IntakeCategory {
  id: string;
  label: string;
  /** Routing hint shown under the label, e.g. "Code Enforcement". */
  department: string;
}

export const MOCK_CATEGORIES: IntakeCategory[] = [
  { id: "junk-vehicle", label: "Junk / abandoned vehicle", department: "Code Enforcement" },
  { id: "tall-grass", label: "Tall grass / weeds", department: "Code Enforcement" },
  { id: "street-drainage", label: "Pothole / street / drainage", department: "Public Works" },
  { id: "trash-debris", label: "Trash / debris", department: "Code Enforcement" },
  { id: "property-maintenance", label: "Property maintenance", department: "Code Enforcement" },
  { id: "other", label: "Something else", department: "We'll route it to the right department" },
];
